import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {closeFlow, RegistrationFlowStep, setStep} from "../../auth/state/registration_flow_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserPhoneVerificationProvider} from "../providers/UserPhoneVerificationProvider";

interface IProps {
    isOpen: boolean;
    onSuccess?: () => void;
}

export const UserPhoneVerification = (props: IProps) => {
    const {isOpen, onSuccess} = props;
    const dispatch = useAppDispatch();

    const handleClose = () => {
        dispatch(closeFlow());
    };

    const handleChangeNumber = () => {
        dispatch(setStep({step: RegistrationFlowStep.PHONE_COMPLETION}));
    };

    return (
        <UserPhoneVerificationProvider>
            <UserPhoneVerificationBase isOpen={isOpen} onClose={handleClose} onSuccess={onSuccess} onChangeNumber={handleChangeNumber} />
        </UserPhoneVerificationProvider>
    );
};
import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {closeFlow, RegistrationFlowStep, setStep} from "../../auth/state/registration_flow_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserPhoneVerificationProvider} from "../providers/UserPhoneVerificationProvider";

interface IProps {
    isOpen: boolean;
    onSuccess?: () => void;
}

export const UserPhoneVerification = (props: IProps) => {
    const {isOpen, onSuccess} = props;
    const dispatch = useAppDispatch();

    const handleClose = () => {
        dispatch(closeFlow());
    };

    const handleChangeNumber = () => {
        dispatch(setStep({step: RegistrationFlowStep.PHONE_COMPLETION}));
    };

    return (
        <UserPhoneVerificationProvider>
            <UserPhoneVerificationBase isOpen={isOpen} onClose={handleClose} onSuccess={onSuccess} onChangeNumber={handleChangeNumber} />
        </UserPhoneVerificationProvider>
    );
};
